// src/scenes/contributions/ShareForm.jsx
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Alert,
  Typography,
} from "@mui/material";

const ShareForm = ({
  open,
  onClose,
  onSubmit,
  saving,
  defaultYear,
  existingShares,
}) => {
  const [shares, setShares] = useState("");
  const [year, setYear] = useState(defaultYear || "");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setShares(existingShares != null ? String(existingShares) : "");
      setYear(defaultYear || "");
      setError("");
    }
  }, [open, defaultYear, existingShares]);

  const handleSave = async () => {
    setError("");

    const sharesNum = Number(shares);
    const y = String(year || "").trim();

    if (!sharesNum || sharesNum <= 0) {
      setError("Please enter a valid shares number (greater than 0).");
      return;
    }
    if (!y || y.length !== 4) {
      setError("Please enter a valid year e.g. 2026.");
      return;
    }

    await onSubmit?.({ shares: sharesNum, year: y });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Set My Shares</DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
          Shares determine your contribution weighting (e.g., investment shareholding).
        </Typography>

        {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}

        <Stack spacing={2}>
          <TextField
            label="Shares"
            type="number"
            value={shares}
            onChange={(e) => setShares(e.target.value)}
            fullWidth
            disabled={saving}
          />

          <TextField
            label="Year"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            fullWidth
            disabled={saving}
            placeholder="2026"
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareForm;
